/* eslint-disable no-throw-literal */
import './index.scss';
import 'antd-mobile/lib/toast/style/css';
import 'antd-mobile/lib/modal/style/css';
import * as React from 'react';
import Toast from 'antd-mobile/lib/toast';
import Modal from 'antd-mobile/lib/modal';
import { tdwReport } from '@tencent/imutils/dist/esm/util_26_tdw_report';
import { objectToQueryString } from '@tencent/imutils/dist/esm/util_09_url';
import axios from 'axios';
import {
  isChildrenEmpty,
  postCRM,
  fudaoMainColor,
  gdtReport,
  GDT_TYPES_MAP,
  postCRMTransferIntro,
} from '../../lib/utils';
import { EmptyData } from '../../lib/components/EmptyData';
import { formatCRMData, formatCRMTransferIntroData } from './utils';

function postForm(values, meta, isAsync) {
  const { actId, actKey, title, isTestEnv } = meta;
  const data = objectToQueryString({
    // TODO
    form_key: 0,
    act_id: actId,
    act_name: title,
    act_key: actKey,
    fr: tdwReport.getFromValue(),
    values: JSON.stringify(values),
    env: isTestEnv ? 'test' : 'production',
  });
  return axios
    .post('//data.fudao.qq.com/cgi/form', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .catch(err => {
      if (!isAsync) {
        throw err;
      }
      console.error(err);
      window.imlogger.error('FormContainer postForm faile with:', err);
      window.imlogger.info('FormContainer postForm missing data:', data);
    });
}

class FormContainer extends React.PureComponent {
  get disabled() {
    return this.state.hasSubmited && this.props.data.forbidResubmit;
  }

  setFormValue = ({
    key,
    value,
    valid = true,
    beforeSubmit = () => Promise.resolve(true),
  }) => {
    this.formValue[key] = { key, value, valid, beforeSubmit };
  };

  formValue = {};

  state = {
    setFormValue: this.setFormValue,
    showVerifyInfo: false,
    hasSubmited: false,
  };

  componentDidMount() {
    if (this.props.on) {
      this.props.on('submit', this.onSubmit);
    }
  }

  report = (data, noCRM) => {
    const reqData = formatCRMData(data);
    if (!noCRM) {
      this.reportCRM(reqData);
    }
    this.reportGDT(reqData);
  };

  reportCRM = reqData => {
    if (!reqData || !reqData.fr) {
      return;
    }
    postCRM(reqData)
      .then(resp => console.log('提交CRM: ', resp))
      .catch(err => {
        console.log('提交CRM失败:', err);
        window.imlogger.error('FormContainer postCRM faile with:', err);
        window.imlogger.info(
          'FormContainer postCRM missing data:',
          JSON.stringify(reqData)
        );
      });
  };

  reportGDT = reqData => {
    const params = { actionType: GDT_TYPES_MAP.RESERVATION };
    if (reqData.phone) {
      const {
        meta: { actId },
        componentKey,
      } = this.props;

      params.externalActionId = `${actId}-${componentKey}-${reqData.phone}`;
      params.outerActionId = `${actId}-${componentKey}-${reqData.phone}`;
    }
    gdtReport(params);
  };

  reportCRMTransferIntro = async reqData => {
    if (!reqData || !reqData.fr) {
      return;
    }
    let res;
    try {
      res = await postCRMTransferIntro(reqData);
    } catch (err) {
      throw new Error(`表单提交失败${err.message}`);
    }
    const {
      data: {
        result: { errcode, errmsg },
        retcode,
      },
    } = res;
    if (retcode !== 0) {
      throw new Error(`网络错误，请稍后重试（[${retcode}]）`);
    }
    if (errcode === 0) {
      return;
    }
    if (errcode === 503021) {
      throw new Error('提交失败：留咨老用户');
    }
    throw new Error(`网络错误，请稍后重试（[${errcode}][${errmsg}]）`);
  };

  // 默认的提交逻辑
  // 以提交 vision data 为主流程反馈 UI，异步上报 CRM 和 GDT
  submitNormal = async formData => {
    const {
      data: { retcode, msg },
    } = await postForm(formData, this.props.meta);
    if (retcode !== 0) {
      throw new Error(`表单提交失败${msg}`);
    }
    setTimeout(() => {
      this.report(formData);
    }, 0);
  };

  // fr 为转介绍的提交逻辑
  // 以提交 4.0 CRM 为主流程反馈 UI，异步上报 vision data 和 GDT
  submitFrZjs = async formData => {
    const reportData = formatCRMTransferIntroData(formData);
    await this.reportCRMTransferIntro(reportData);
    setTimeout(() => {
      postForm(formData, this.props.meta, true);
      this.report(formData, true);
    }, 0);
  };

  onSubmit = async () => {
    if (this.disabled) {
      return console.log('skip submit');
    }

    if (this.props.data.forbidResubmit && this.state.hasSubmited) {
      return Toast.info('你已经提交过了，无需重复提交~');
    }

    const maps = Object.entries(this.formValue).map(([_, i]) => i);
    for (const i of maps) {
      if (!i.valid) {
        return this.setState({ showVerifyInfo: true });
      }
    }

    Toast.loading('提交中', 0);
    try {
      const result = await Promise.all(
        maps.map(({ beforeSubmit }) => beforeSubmit())
      );
      for (const r of result) {
        if (r === false) {
          return;
        }
      }

      const formData = maps.map(({ key, value }) => ({ key, value }));
      const fr = tdwReport.getFromValue();
      if (fr === 'zjs') {
        await this.submitFrZjs(formData);
      } else {
        await this.submitNormal(formData);
      }
    } catch (e) {
      console.error(e);
      Toast.hide();
      return Toast.fail(e.message);
    }
    Toast.hide();
    this.setState({ hasSubmited: true });

    const { jumpURL, successText, successTitle, messageType } = this.props.data;
    const callback = () => {
      if (jumpURL && jumpURL.trim()) {
        window.location.href = jumpURL;
      } else {
        this.props.emit('submitSuccess');
      }
    };
    messageType === 'toast'
      ? Toast.success(successText, 2, callback)
      : Modal.alert(successTitle, successText, [
          { text: '确定', onPress: callback, style: { color: fudaoMainColor } },
        ]);
  };

  render() {
    const {
      data: { buttonText, successButtonText },
      style: { buttonTextColor, buttonBackgroundColor } = {},
      children,
      commonStyle,
    } = this.props;

    if (isChildrenEmpty(children)) {
      return <EmptyData text="未添加任何表单子组件" />;
    }

    return (
      <div className="fudao-form-container" style={commonStyle}>
        {React.Children.map(children, i => {
          return React.cloneElement(i, {
            ...this.state,
            background: commonStyle.background || commonStyle.backgroundColor,
          });
        })}
        <button
          type="button"
          className="fudao-form-submit"
          onClick={this.onSubmit}
          style={
            this.disabled
              ? {
                  backgroundColor: '#cccccc',
                  color: '#fff',
                }
              : {
                  backgroundColor: buttonBackgroundColor || '#FFC94D',
                  color: buttonTextColor || '#000',
                }
          }
        >
          {this.state.hasSubmited ? successButtonText : buttonText}
        </button>
      </div>
    );
  }
}

export default FormContainer;
